(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("transferEmployeeButton", {
            controller: TransferEmployeeButtonComponent,
            bindings: {
                onClick: '&',
                type: '@',
                usersData: '<',
                brandId: '<'
            },
            controllerAs: 'transferEmployeeButton',
            templateUrl: '../hmodules/on-boarding/components/transfer-employee-button/transfer-employee-button.component.html'
        });

    TransferEmployeeButtonComponent.$inject = ['$scope', '$modal', '$filter', '$q', 'brandServices', 'userServices'];

    function TransferEmployeeButtonComponent($scope, $modal, $filter, $q, brandServices, userServices) {

        var self = this;
        self.loading = false;

        var checkOpenEVerifyCases = function (prospectIds) {
            var defer = $q.defer();

            brandServices.check(brandServices.SERVICES.E_VERIFY, self.users[0].brand_id)
                .then(function (isEVerifyServiceEnabled) {
                    if (isEVerifyServiceEnabled) {
                        EVerifyAPI.getEverifyCasesForProspects(self.users[0].brand_id, prospectIds, false)
                            .then(function (res) {
                                var cases = res.cases;
                                var atLeastOneOpenCase = false;
                                for (var i in cases) {
                                    var tempCase = cases[i];
                                    if ([EVerifyAPI.STATUSES.CLOSED, EVerifyAPI.STATUSES.NOT_STARTED].indexOf(tempCase.status) === -1) {
                                        atLeastOneOpenCase = true;
                                        break;
                                    }
                                }
                                defer.resolve(atLeastOneOpenCase);
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject();
                            });
                    } else {
                        defer.resolve(false);
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject();
                });

            return defer.promise;
        };

        self.$onInit = function () {
            if (typeof (self.usersData) !== 'undefined') {
                self.users = angular.copy(self.usersData);
            }
        };

        self.$onChanges = function (changes) {
            if (
                changes.usersData &&
                !changes.usersData.isFirstChange() &&
                JSON.stringify(changes.usersData.currentValue) !== JSON.stringify(changes.usersData.previousValue)
            ) {
                self.users = angular.copy(changes.usersData.currentValue);
            }
        };

        self.onButtonClicked = function () {

            if (!self.users.length) {
                hAlert(
                    $filter("translate")('Move Employees'),
                    $filter("translate")("Please select candidates before moving them."),
                    function () {},
                    'h-general-error-alert'
                );
            } else {
                var multipleLocations = false;
                for (var i in self.users) {
                    var user = self.users[i];
                    if (self.users[i+1] && (user.brand_id !== self.users[i+1].brand_id)) {
                        multipleLocations = true;
                        break;
                    }
                }

                if (multipleLocations) {
                    hAlert($filter("translate")('Move Employees'),
                        $filter("translate")("Bulk transfer employees to multiple locations is not allowed, Please filter by location before transferring the selected employees."));
                } else {
                    var prospectIds = _.map(self.users, function (user) {
                        return user.prospect_id || user.default_prospects && user.default_prospects[0];
                    });

                    self.loading = true;
                    var promises = {};
                    promises['checkOpenCases'] = checkOpenEVerifyCases(prospectIds);
                    $q.all(promises)
                        .then(function (result) {
                            var atLeastOneOpenCase = result['atLeastOneOpenCase'];
                            if (atLeastOneOpenCase) {
                                hAlert($filter("translate")('Move Employees'),
                                    $filter("translate")("You cannot transfer employees while there is an open case in E-verify, Please close the case first then transfer."));
                            } else {
                                $modal({
                                    controller: 'TransferEmployeeModal',
                                    controllerAs: 'TransferEmployeeModal',
                                    templateUrl: '../hmodules/on-boarding/modals/transfer-employee/transfer-employee.modal.html',
                                    show: true,
                                    backdrop: 'static',
                                    resolve: {
                                        modalData: function () {
                                            return {
                                                users: self.users
                                            };
                                        }
                                    }
                                });
                            }
                        })
                        .catch(function () {
                            hAlert($filter("translate")('Move Employees'),
                                $filter("translate")("Something went wrong!"));
                        })
                        .finally(function () {
                            self.loading = false;
                        });
                    }
            }

            self.onClick();
        };
    }
})();
